AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Master");

AoPS.Alcumus.Models.Master = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMUser = AoPS.Alcumus.Models.User;
	// Optional; will lose some functionality but will not error without
	var AlcMHof = AoPS.Alcumus.Models.HallOfFame;

	return AlcMBase.BaseModel.extend({
		defaults: {
			user_id: -1,
			is_admin: false,
			logged_in: false,
			subject_order: null,
		},
		/** Additional attributes:
			(A + means an optional dependency is required; only use it if you can be
			  sure that dependency will be loaded.)
			user_me: User model for logged in user
			users: collection of User models
			+hall_of_fame: Hall of Fame model
		*/
		/**
			Alcumus in class pages will set additional attributes, like grid_class_id
			and is_self_paced. See m/class/js/grid_router for the full list.
		*/

		initialize: function () {
			this.set("user_me", new AlcMUser({id: -1, is_me: true, master: this}));
			AlcMHof && this.set("hall_of_fame", new AlcMHof({master: this}));

			this.set("users", new AlcMBase.BaseCollection());
			this.get("users").setCreateFunction(
				_.bind(function (id) {
					return new AlcMUser({id: id, master: this});
				}, this)
			);
			// Note: can't add 'me' user to collection until ID is determined.
		},

		// The user_id attribute on the master model must be properly set before
		// calling this method.
		requestLoad: function (callback, context) {
			// master model considers itself loaded when the 'me' user is.
			// Load requests are immediately delegated to it.
			var user_id = this.get("user_id");
			var user_me = this.get("user_me");

			if (user_id <= 0) {
				callback(false, {
					error_code: "E_INVALID_INPUT",
					error_msg: "The master model user ID must be set before loading.",
				});
			} else {
				// 'me' user needs an ID to load properly.
				user_me.set("id", user_id);
				this.set("logged_in", AoPS.session.logged_in);
				this.set("initialized", AoPS.session.initialized);
				// Now that we have an ID, add to the master's user collection.
				this.get("users").add(user_me);
				return user_me.requestLoad(callback, context);
			}
		},

		unpack: function (data) {
			var user_me = this.get("user_me");

			if (!data) {
				return;
			}

			if (data.subject_order) {
				this.set("subject_order", data.subject_order);
			}

			if (data.user) {
				user_me.unpack(data.user);
				this.get("users").add(user_me);
			}
			this.get("users").unpackAll(data.users, "user_id");
			this.get("hall_of_fame").unpack(data.hall_of_fame);
		},

		// 'me' and the 'me' ID number both return true here.
		isMyId: function (user_id) {
			var user = this.getUser(user_id);
			return user && user.get("is_me");
		},

		isTeacher: function () {
			return this.get("user_me").get("is_teacher");
		},

		// Gives a uniform interface for querying for user both in terms
		// of user ID and with the special 'me' value.
		getUser: function (user_id) {
			if (user_id === "me") {
				return this.get("user_me");
			} else {
				return this.get("users").get(user_id);
			}
		},

		// getOrCreate version of getUser.
		getOrCreateUser: function (user_id) {
			if (user_id === "me") {
				return this.get("user_me");
			} else {
				return this.get("users").getOrCreate(user_id);
			}
		},

		specialAjax: function (ajax_data, callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"special",
				ajax_data,
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.unpack(data);
					callback(true, data);
				}, this)
			);
		},
	});
})();
